export enum Role {
  ADMIN = 'admin',
  OPERATOR = 'operator',
  PIC = 'pic',
  MASTER_ADMIN = 'master_admin',
  MASTER_PIC = 'master_pic',
  MASTER_OPERATOR = 'master_operator',
}
